import { render } from "./DatabasesSqlSaperaViewComponent.vue?vue&type=template&id=0424e204"
import script from "./DatabasesSqlSaperaViewComponent.vue?vue&type=script&lang=js"
export * from "./DatabasesSqlSaperaViewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__